import React from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import UI5CalendarRange from "../../../../../../gd-components/datetime/calendar-v2/calendar-range"
import {EventType} from "../../../../../../gd/const/event"

import DatepickerContent from "../../../../../../gd-components/datetime/datepicker/datepicker-content"

// const debug = false
const debug = "FieldEventStartEnd_Popover"

export default function FieldEventStartEnd_Popover(props:any) {

    const onSelectDate = (date:Moment|null) => {
        props.parent.hidePopover();
        props.parent.onValueChange(date)
    }

    const onSelectRange = (dateRange:MomentRange|null) => {
        props.parent.hidePopover();
        props.parent.onValueChange(dateRange);
    }

    debug && console.log(debug, 'render', props)

    const popoverPosition = new PopoverPosition({
        attachment      : "top center",
        targetAttachment: "bottom center",
    })

    switch (props.parent.props.model.type) {
        case EventType.PROJECT_MILESTONE:
            return (
                <Popover position       = {popoverPosition}
                         getTargetFunc      = {()=>findDOMNode(props.parent)}
                         onClickOutside     = {()=>{props.parent.hidePopover()}}>
                    <DatepickerContent value        = {props.value}
                                       onSelect     = {onSelectDate}
                                       minDate      = {props.field.minDate}
                                       maxDate      = {props.field.maxDate}/>
                </Popover>
            )

        default:
            let value = null
            if (props.parent.state?.currentValue) {
                value = props.parent.state.currentValue
            } else {
                value = props.parent.value // fix for editable case ?
            }

            return (
                <Popover className="daterange-picker-popover" position={popoverPosition}
                         getTargetFunc={()=>findDOMNode(props.parent)}
                         onClickOutside={()=>{props.parent.hidePopover()}}>

                    <UI5CalendarRange selectedRange = {value}
                                      minDate       = {props.field.minDate}
                                      maxDate       = {props.field.maxDate}
                                      presets       = {false}
                                      onSelect      = {onSelectRange}/>
                </Popover>
            )
    }
}